
// @todo get all CSS into the template css file so we don't have all that in the bootstrap file.

define('views/template/rightColumn/index',[
	"ssi!fragment/rightcolumn/index"
], function(template) {

	return Backbone.View.extend({

		events: {
			"click #headlineList a": "headlineView"
		},

		// ie9Responsize: function() {
		//
		// 	if($(window).width() < 1100)
		// 		this.$el.hide();
		// 	else
		// 		this.$el.show();
		// },

		headlineView: function(e) {
			var type = 'rss',
				id = $(e.currentTarget).attr("headlineid"),
				url = e.currentTarget.href;

			if(document.images){
			    (new Image()).src="//www."+window.config.rootdomain+"/client/redirect.php?R=true&url="+url+
			    "&from="+type+"&id="+id;
			}
			return true;
		},

		initialize: function() {

			if(!this.$el.html())
				this.render();

			// when a tooltip is applied title is changes to a[data-original-title] so we need to do this
			// for preloaded html.
			this.$("a[title], a[data-original-title]").each(function() {

				Backbone.$(this).tooltip({placement: 'left'});

			});

			// Hack to get right column to the bottom of the page.
			//try {
			// if(!window.preloadCss) {
			//   setTimeout(_.bind(function() {
			  var height_of_column = this.$el.outerHeight() + this.$el.offset().top;
			  var height_of_page = $(window).height();
			  this.$el.css({minHeight: this.$el.height() + height_of_page - height_of_column});
			//   }, this), 100);
			// }


			// Lets use Ghetto JS repsonsive design for ie9.
			// if($("html").hasClass("ie9")) {
			// 	$(window).resize(_.bind(this.ie9Responsize, this));
			// }

		},

		render: function() {
			this.$el.html(template);
		}


	});

});
